export type ReactTitleProps = {
  id?: string
  style: ReactTitleDesignTokens
  text: string
  isInEditor?: boolean
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  lob?: string
}

export enum ReactTitleDesignTokens {
  DISPLAY1 = 'cox-text-display1',
  DISPLAY2 = 'cox-text-display2',
  DISPLAY3 = 'cox-text-display3',
  HEADING1 = 'cox-text-heading1',
  HEADING2 = 'cox-text-heading2',
  HEADING3 = 'cox-text-heading3',
  HEADING4 = 'cox-text-heading4',
  HEADING5 = 'cox-text-heading5',
  HEADING6 = 'cox-text-heading6',
  MEDIUM1 = 'cox-text-title1-medium',
  MEDIUM2 = 'cox-text-title2-medium',
  MEDIUM3 = 'cox-text-title3-medium',
  MEDIUM4 = 'cox-text-title4-medium',
  BOLD1 = 'cox-text-title1-bold',
  BOLD2 = 'cox-text-title2-bold',
  BOLD3 = 'cox-text-title3-bold',
  BOLD4 = 'cox-text-title4-bold'
}
